function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-478.354 -3148.35)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M511.136,3148.723a10.874,10.874,0,0,1,7.342.611h0a10.909,10.909,0,0,0,9.042,0h0a10.9,10.9,0,0,1,13.395,3.589h0a10.9,10.9,0,0,0,7.831,4.521h0a10.9,10.9,0,0,1,9.806,9.8h0a10.9,10.9,0,0,0,4.52,7.831h0a10.9,10.9,0,0,1,3.59,13.4h0a10.9,10.9,0,0,0,0,9.042h0a10.9,10.9,0,0,1-3.59,13.4h0a10.9,10.9,0,0,0-4.52,7.83h0a10.9,10.9,0,0,1-9.806,9.806h0a10.9,10.9,0,0,0-7.831,4.521h0a10.9,10.9,0,0,1-13.395,3.589h0a10.9,10.9,0,0,0-9.042,0h0a10.9,10.9,0,0,1-13.4-3.589h0a10.9,10.9,0,0,0-7.83-4.521h0a10.9,10.9,0,0,1-9.806-9.806h0a10.9,10.9,0,0,0-4.521-7.83h0a10.9,10.9,0,0,1-3.589-13.4h0a10.9,10.9,0,0,0,0-9.042h0a10.9,10.9,0,0,1,3.589-13.4h0a10.9,10.9,0,0,0,4.521-7.831h0a10.9,10.9,0,0,1,9.806-9.8h0a10.9,10.9,0,0,0,7.83-4.521h0A10.88,10.88,0,0,1,511.136,3148.723Z",
  fill: "#999"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 37.182,
  cy: 37.182,
  r: 37.182,
  transform: "translate(485.817 3155.813)",
  fill: "none",
  stroke: "#e6e6e6",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M531.878,3194.613c-.056,2.55-3.835,4.607-8.489,4.607s-8.433-2.057-8.488-4.607a13.988,13.988,0,0,0-12.7,13.926c0,7.725,6.262,7.7,13.986,7.7h14.4c7.723,0,13.985.02,13.985-7.7A13.986,13.986,0,0,0,531.878,3194.613Z",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.389,3194.174c-4.724,0-8.628-5.122-9.255-11.77h-1.285c.714,7.572,5.159,13.406,10.54,13.406s9.827-5.834,10.54-13.406h-1.285C532.016,3189.052,528.114,3194.174,523.389,3194.174Z",
  fill: "#e6e6e6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M512.348,3180.829H534.43a1.557,1.557,0,1,0,0-3.115h-.424a10.619,10.619,0,0,0-5.823-9.473l-.88,4.989a.812.812,0,0,1-.8.672.891.891,0,0,1-.143-.011.816.816,0,0,1-.66-.943l1.005-5.7a2.132,2.132,0,0,0-1.81-1.005h-3.013a2.133,2.133,0,0,0-1.809,1.005l1.005,5.7a.814.814,0,0,1-.66.943.879.879,0,0,1-.142.011.813.813,0,0,1-.8-.672l-.88-4.988a10.611,10.611,0,0,0-5.823,9.472h-.424a1.557,1.557,0,1,0,0,3.115Z",
  fill: "#e6e6e6"
}));

var SvgEngineer = function SvgEngineer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89.29,
    height: 89.291,
    viewBox: "0 0 89.29 89.291",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEngineer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/engineer.7876363d.svg";
export { ForwardRef as ReactComponent };